import { createSelector } from '@reduxjs/toolkit';
import * as R from 'ramda';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { Filter, FilterInputType, SelectedFilterOption } from 'src/types';
import { getTitleFromFilterOptionUid } from './selectorHelpers';
import { selectFilters, selectSelectedFilterOptions } from './selectors';

export enum FilterOptionSelectionTypes {
  SELECT = 'SELECT',
  DESELECT = 'DESELECT',
}

const selectFilterOptionPayload = (_state: ReduxApplicationState, payload: SelectedFilterOption) =>
  payload;

interface FilterOptionSelection {
  type: FilterOptionSelectionTypes;
  filterTitle: string;
  filterOptionTitle: string;
}

export const selectFilterOptionSelection = createSelector<
  ReduxApplicationState,
  SelectedFilterOption,
  Filter[],
  SelectedFilterOption[],
  SelectedFilterOption,
  FilterOptionSelection
>(
  [selectFilters, selectSelectedFilterOptions, selectFilterOptionPayload],
  (filters, selectedFilterOptions, payload) => {
    const { filterOptionValue, filterUid, filterOptionUid } = payload;

    const filter = filters.find((filter) => filter.uid === filterUid);

    if (Array.isArray(filterOptionValue)) {
      const { filterOptionValue: values } = selectedFilterOptions.find(
        (selectedFilter) => selectedFilter.filterUid === filterUid,
      ) ?? { filterOptionValue: [] };

      const selectedOption = R.difference(filterOptionValue, values as string[]).join('');
      const deslectedOption = R.difference(values as string[], filterOptionValue).join('');

      const valueToMatch = selectedOption || deslectedOption;

      const filterOptionTitle = filter!.options.find(({ value }) => value === valueToMatch)!.title;

      const type = selectedOption
        ? FilterOptionSelectionTypes.SELECT
        : FilterOptionSelectionTypes.DESELECT;

      return { type, filterTitle: filter!.title, filterOptionTitle };
    } else {
      let filterOptionTitle;

      if (filter!.type == FilterInputType.Range && filterOptionUid) {
        filterOptionTitle = `${getTitleFromFilterOptionUid(filterOptionUid)}:${filterOptionValue}`;
      } else {
        filterOptionTitle = filter!.options.find(({ value }) => value === filterOptionValue)!.title;
      }

      return {
        type: FilterOptionSelectionTypes.SELECT,
        filterTitle: filter!.title,
        filterOptionTitle,
      };
    }
  },
);
